module.exports = __webpack_public_path__ + "img/5-1.e18582f1.svg";